
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProgressBar",
  props: {
    progress: {
      type: Number,
    },
  },
});
